import React from "react";

const Comment = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.6504 0C18.1053 0 18.4866 0.160374 18.8135 0.491211C19.1405 0.822335 19.3007 1.21107 19.3008 1.67578V19.0498L15.8994 15.6064L15.7969 15.502H1.65039C1.19557 15.502 0.814122 15.3425 0.487305 15.0117C0.160369 14.6806 4.84165e-05 14.2918 0 13.8271V1.67578C3.50742e-05 1.21107 0.160304 0.822335 0.487305 0.491211C0.814147 0.160373 1.19551 0 1.65039 0H17.6504ZM1.30078 1.3252V14.1768H16.3564L18 15.8057V1.3252H1.30078ZM15.3008 10.127V11.4521H4V10.127H15.3008ZM15.3008 7.08887V8.41406H4V7.08887H15.3008ZM15.3008 4.05078V5.37598H4V4.05078H15.3008Z"
      fill={color}
    />
  </svg>
);

Comment.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Comment;
